import request from "../../../request";
import axios from "axios";
import {baseUrl} from "../../../config";

export default {
    state: {
        user: null,
        token: localStorage.getItem("access_token") || null,
        roles: null,
        smsBalance: 0,
        companies: [],
    },
    getters: {
        user: state => state.user,
        access_token: state => state.token,
        roles: state => state.roles,
        smsBalance: state => state.smsBalance,
        companies: state => state.companies,
    },
    mutations: {
        setAccessToken(state, token) {
            state.token = token;
        },
        deleteAccessToken(state) {
            state.accessToken = null
        },
        setUser(state, user) {
            state.user = user;
        },
        deleteUser(state) {
            state.user = null
        },
        setRoles(state, roles) {
            state.roles = roles;
        },
        setCompanies(state, companies) {
            state.companies = companies
            if (state.companies != undefined)
                state.companies.unshift({
                    'text': 'Tüm Bayiler',
                    'value': null,
                })
        },
        deleteRoles(state) {
            state.roles = null;
        },
        setSMSBalance(state, balance) {
            state.smsBalance = balance;
        },
    },
    actions: {
        // get current user
        getUser({commit}) {
            return request.get('user')
                .then(data => data.data)
                .then(response => {
                    const user = response.user
                    user.company = response.company
                    commit("setSMSBalance", response.balance)
                    commit("setAccessToken", response.access_token)
                    commit("setUser", user)
                    commit("setRoles", response.roles)
                    commit("setCompanies", response.companies)
                    return user;
                })
        },
        // Login action
        login(_, request) {
            return new Promise((resolve, reject) => {
                axios
                    .post(baseUrl + "login", {
                        email: request.email,
                        password: request.password
                    })
                    .then(res => res.data)
                    .then(response => {
                        localStorage.setItem("access_token", response.access_token)
                        resolve(true)
                    }).catch(error => {
                    reject(error)
                })
            })
        },

        // register action
        register(_, request) {
            return new Promise((resolve, reject) => {
                axios.post(baseUrl + 'register', request)
                    .then(res => res.data)
                    .then(response => {
                        localStorage.setItem("access_token", response.access_token)
                        resolve(true)
                    }).catch(error => {
                    reject(error)
                })
            })
        },

        // Logout Action
        logout({commit}) {
            return new Promise(resolve => {
                commit('deleteAccessToken')
                commit('deleteUser')
                commit('deleteRoles')
                localStorage.removeItem("access_token")
                resolve(true)
            });
        },
    }
}
